import { Component } from '@angular/core';

@Component({
  selector: 'glm-migrate-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'LPS Migration Portal';
}
